export default function checkModule(modules: { name: string }[], moduleName: string) {
  if (!moduleName) return false;
  if (modules.some((module) => module.name.toLowerCase() === moduleName.toLowerCase())) {
    return true;
  }

  return false;
}
